import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';

const ContactusSection = ({data}) => {

    const [activeTooltip, setActiveTooltip] = useState(null);
    return (

        <section className="contact_section">
            <div className="contact_wrapper">
                <div className="contact_row">
                    <div className="contact_column_left">
                        <h2 className="contact_title">
                            {data?.data_center_heading}
                        </h2>
                        <h3 className="contact_subtitle">
                            {data?.data_center_paragraph}
                        </h3>
                        <Link to={data?.islamabad_button_url}className="green_btn green_btn_active islamabad_btn" onMouseLeave={(e) => setActiveTooltip(0)} onMouseEnter={(e) => setActiveTooltip(1)}>
                            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data?.islamabad_button_icon || "") }} >
                            </div>
                            {data?.islamabad_button_text}
                        </Link>
                        <br />
                        <Link to={data?.lahore_button_url} className="green_btn lahore_btn" onMouseLeave={(e) => setActiveTooltip(0)} onMouseEnter={(e) => setActiveTooltip(2)}>
                            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data?.lahore_button_icon || "") }} >
                            </div>
                            {data?.lahore_button_text}
                        </Link>
                        <br />
                        <Link to={data?.karachi_button_url} className="green_btn karachi_btn" onMouseLeave={(e) => setActiveTooltip(0)} onMouseEnter={(e) => setActiveTooltip(3)}>
                            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data?.karachi_button_icon || "") }} >
                            </div>
                            {data?.karachi_button_text}
                        </Link>
                    </div>
                    <div className="contact_column_right">
                        <div className="map_container">
                            <div className="map_placeholder">
                                <img src="assets/img/Map.webp" width={554} height={458} alt="map" className="map_image" />
                                <div className={activeTooltip === 1 ? "tooltip_one tooltip active" : "tooltip_one tooltip"}>
                                    <span className="tooltiptext"></span>
                                    <div className="tooltip_content">
                                        <div className="tooltip_flex">
                                            <div className="tooltip_image">
                                                <img src="assets/img/SKY 47 LOGO.svg" width={100} height={64} alt="Islamabad" />
                                            </div>
                                            <div className="tooltip_text">
                                                <h3>{data?.islamabad_tooltip_text}</h3>
                                                <p className="status">{data?.islamabad_tooltip_status_text}</p>
                                                <a href={data?.islamabad_tooltip_map_button_url} target="_blank" className="map_button">Open
                                                    Map</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={activeTooltip == 3 ? "tooltip_two tooltip active" : "tooltip_two tooltip"}>
                                    <span className="tooltiptext"></span>
                                    <div className="tooltip_content">
                                        <div className="tooltip_flex">
                                            <div className="tooltip_image">
                                                <img src="assets/img/SKY 47 LOGO.svg" width={100} height={64} alt="Karachi" />
                                            </div>
                                            <div className="tooltip_text">
                                                <h3>{data?.karachi_tooltip_text}</h3>
                                                <p className="status">{data?.karachi_tooltip_status_text}</p>
                                                <a href={data?.karachi_tooltip_map_button_url} target="_blank" className="map_button">Open
                                                    Map</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={activeTooltip == 2 ? "tooltip_three tooltip active" : "tooltip_three tooltip"}>
                                    <span className="tooltiptext"></span>
                                    <div className="tooltip_content">
                                        <div className="tooltip_flex">
                                            <div className="tooltip_image">
                                                <img src="assets/img/SKY 47 LOGO.svg" width={100} height={64} alt="Lahore" />
                                            </div>
                                            <div className="tooltip_text">
                                                <h3>{data?.lahore_tooltip_text}</h3>
                                                <p className="status">{data?.lahore_tooltip_status_text}</p>
                                                <a href={data?.lahore_tooltip_map_button_url} target="_blank" className="map_button">Open
                                                    Map</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactusSection;